var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconWebps = function SvgIconWebps(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 1.15286,
    width: 26.75,
    height: 26.75,
    rx: 5.375,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 1.15286,
    width: 26.75,
    height: 26.75,
    rx: 5.375,
    fill: "#F4FCFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 1.15286,
    width: 26.75,
    height: 26.75,
    rx: 5.375,
    stroke: "#5BD2DB",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10.5906H14.5004L13.188 9.27823H9.25074C8.52892 9.27823 7.9449 9.86881 7.9449 10.5906L7.93834 18.4651C7.93834 19.1869 8.52892 19.7775 9.25074 19.7775H19.75C20.4718 19.7775 21.0624 19.1869 21.0624 18.4651V11.903C21.0624 11.1812 20.4718 10.5906 19.75 10.5906ZM19.75 18.4651H9.25074V10.5906H12.6433L13.9557 11.903H19.75V18.4651ZM16.469 15.184C17.1908 15.184 17.7814 14.5935 17.7814 13.8716C17.7814 13.1498 17.1908 12.5592 16.469 12.5592C15.7471 12.5592 15.1566 13.1498 15.1566 13.8716C15.1566 14.5935 15.7471 15.184 16.469 15.184ZM13.8442 17.8089H19.0938V17.1527C19.0938 16.2799 17.3417 15.8402 16.469 15.8402C15.5962 15.8402 13.8442 16.2799 13.8442 17.1527V17.8089Z",
    fill: "#24C3CF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconWebps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-webps.0e9712bf798f83cc52977e5c12d4417c.svg";